import { c as _c } from "react/compiler-runtime";
import { FILTER_TYPE } from '../Filters.types';
import type { UpdateFiltersProps } from './AdditionalFilters';
import FilterDropdown from './FilterDropdown';
interface Props {
  selectedFilters: { [key in FILTER_TYPE]: Array<string> };
  updateFilters: (values: UpdateFiltersProps) => () => void;
  resetFilter: (type: FILTER_TYPE) => () => void;
  handleApply: () => void;
  undoFilterSelection: () => void;
}
const FilterDropdowns = t0 => {
  const $ = _c(15);
  const {
    selectedFilters,
    updateFilters,
    resetFilter,
    handleApply,
    undoFilterSelection
  } = t0;
  const t1 = selectedFilters[FILTER_TYPE.LOCATION_OFFERING];
  let t2;
  if ($[0] !== handleApply || $[1] !== resetFilter || $[2] !== t1 || $[3] !== undoFilterSelection || $[4] !== updateFilters) {
    t2 = <FilterDropdown filterType={FILTER_TYPE.LOCATION_OFFERING} selectedFilters={t1} updateFilters={updateFilters} resetFilter={resetFilter} handleApply={handleApply} undoFilterSelection={undoFilterSelection} />;
    $[0] = handleApply;
    $[1] = resetFilter;
    $[2] = t1;
    $[3] = undoFilterSelection;
    $[4] = updateFilters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = selectedFilters[FILTER_TYPE.LEVEL];
  let t4;
  if ($[6] !== handleApply || $[7] !== resetFilter || $[8] !== t3 || $[9] !== undoFilterSelection || $[10] !== updateFilters) {
    t4 = <FilterDropdown filterType={FILTER_TYPE.LEVEL} selectedFilters={t3} updateFilters={updateFilters} resetFilter={resetFilter} handleApply={handleApply} undoFilterSelection={undoFilterSelection} />;
    $[6] = handleApply;
    $[7] = resetFilter;
    $[8] = t3;
    $[9] = undoFilterSelection;
    $[10] = updateFilters;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default FilterDropdowns;